import { httpsCallable } from "firebase/functions";
import { functions } from "../../../../shared/libs/firebaseConfig";

const invoke = async (name, data) => (await httpsCallable(functions, name)(data)).data;
export const reviewAdminApi = {
  list: (data) => invoke("adminListCourseReviews", data),
  history: (data) => invoke("adminGetCourseReviewHistory", data),
  suspend: (data) => invoke("adminSuspendCourseReview", data),
  restore: (data) => invoke("adminRestoreCourseReview", data),
  delete: (data) => invoke("adminDeleteCourseReview", data),
};

export function reviewError(error) {
  const code = String(error?.code || "").replace(/^functions\//, "");
  if (code === "aborted") return "รีวิวมีการเปลี่ยนแปลงแล้ว กรุณาตรวจสอบข้อมูลล่าสุดก่อนดำเนินการอีกครั้ง";
  if (code === "permission-denied" || code === "unauthenticated") return "ไม่มีสิทธิ์จัดการรีวิว กรุณาตรวจสอบบัญชีผู้ดูแลระบบ";
  if (code === "failed-precondition") return "ระบบรีวิวยังไม่พร้อมใช้งาน กรุณาลองใหม่ภายหลัง";
  if (code === "not-found") return "ไม่พบรีวิวนี้แล้ว กรุณาโหลดรายการใหม่";
  return "ดำเนินการไม่สำเร็จ กรุณาลองอีกครั้ง";
}

export function thaiReviewDate(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return "—";
  return new Intl.DateTimeFormat("th-TH-u-ca-buddhist", {
    day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Bangkok",
  }).format(new Date(value));
}

// Only accept this field from the authorized callable DTO, never from a raw
// profile or caller input. The backend resolves only validated existing avatars;
// origin/ownership validation is performed there before a non-null DTO is returned.
export function reviewAvatarUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}

export function reviewAuthorName(value) {
  if (typeof value !== "string" || !/\p{L}/u.test(value) || /[@\p{Cc}\p{Cf}]/u.test(value) || /[\d๐-๙]{6}/u.test(value)) return "";
  return value.trim();
}
